import type { Subject } from 'rxjs'
import type { FormWorker } from '../FormWorker'
import type { EmployeSubscriber } from './EmployeSubscriber'

export const runEmployees = (
    employees: FormWorker.Props['employees'],
    employeSubscriber: EmployeSubscriber,
    fieldsChanged: FormWorker.InternalValueField[],
    fieldsMerged: FormWorker.InternalStateFields,
    unitsForm: FormWorker.Props['unitsForm'],
    updaterSubject: Subject<FormWorker.updateSubjects>,
    runType: EmployeSubscriber.runType,
    dispatch: FormWorker.employeesStatusOnNext
): void => {
    if (!employees) {
        return
    }

    employeSubscriber.subscribeEmploye(
        fieldsChanged
            .map(field =>
                field.observerEmployees.map(
                    (e): EmployeSubscriber.EmployeInitializer => ({
                        name: e,
                        config: employees.config[e],
                        slave: employees.slave[e],
                        updaterSubject: updaterSubject,
                        runType: runType,
                        values: fieldsMerged,
                        unitsForm: unitsForm,
                        dispatch: dispatch,
                    })
                )
            )
            .reduce((c, fi) => [...c, ...fi], [])
    )
}
